var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoged)?_c('div',[(_vm.user && _vm.user.has_changed_password == false)?_c('div',[_c('UpdatePassword')],1):_vm._e(),(_vm.user && _vm.user.has_changed_password == true)?[_c('Dashboard',{staticClass:"dashboard-container"})]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }